import { render } from "./ProjectsOverview.vue?vue&type=template&id=3a5bb6ca&ts=true"
import script from "./ProjectsOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__